module.exports = __webpack_public_path__ + "img/cabinet-ostheopathe-barry.5d63a933.jpg";